<template>
  <div>
      <router-view></router-view>
      <v-snackbar bottom right :value="updateExists" color="primary">
          Nueva versión del sistema disponible
          <v-btn text @click="refreshApp">
          Actualizar
          </v-btn>
      </v-snackbar>
  </div>
</template>

<script>

import update from './mixin/update'
export default {
  mixins: [update],
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
<style>
.cursor-pointer{
  cursor: pointer;
}
.h-100{
  height: 100%;
}
</style>